import { Theme } from '@mui/material/styles'

export const cardHover = (theme: Theme) => ({
  '&:hover': {
    transform: 'translate(0, 0) scale(1.02)',
    transition: '.2s ease-in-out',
    boxShadow: `0 1px 6px ${theme.palette.primary.main}`,
  },
} as const)